import React, { ReactNode } from "react";
import { UIFlightData } from "@flights/types";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Link, Stack } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useOneWayCombinationInfo = (flight: UIFlightData) => {
  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!flight.oneWayCombination) return undefined;

  return {
    header: flight.oneWayCombination.heading,
    content: (
      <Stack direction="row" gap={4}>
        <Icon svg={InfoSignIcon} size={condensedFDMobile ? "medium" : "large"} />

        <Stack.Item grow={true}>
          <Trans
            tag="flights_funnel_fd_one_way_description"
            variables={{ start_link: "<0>", end_link: "</0>" }}
            components={[
              ({ children }: { children: ReactNode }) => (
                <Link
                  key={0}
                  href={flight.oneWayCombination?.termsUrl}
                  text={children}
                  attributes={{
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "aria-label": `${children} (${flight.oneWayCombination?.a11y_hint})`
                  }}
                />
              )
            ]}
          />
        </Stack.Item>
      </Stack>
    )
  };
};

export default useOneWayCombinationInfo;
